import { LocalizedLink as Link } from "@/components/LocalizedLink";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import { SCHEMA_TYPES } from "@/lib/seo/schemaTypes";

const TITLE = { en: "Structured data types explained", fr: "Les données structurées expliquées par type", es: "Los datos estructurados explicados por tipo" };

export const GeneratorLinks = () => {
  const { language } = useLanguage();
  return (
    <section className="max-w-4xl mx-auto px-4 py-12 text-center space-y-5">
      <h2 className="text-2xl font-bold">{TITLE[language]}</h2>
      <ul className="flex flex-wrap justify-center gap-2">
        {SCHEMA_TYPES.map((g) => (
          <li key={g.slug}>
            <Link to={`/structured-data/${g.slug}`} className="inline-block text-sm rounded-lg border border-border/60 bg-card/60 px-3 py-2 hover:border-primary/50 transition-colors">
              {g.type}
            </Link>
          </li>
        ))}
      </ul>
      <Link to="/structured-data" className="inline-block text-sm text-primary hover:underline">
        {language === "fr" ? "Comprendre les données structurées : le guide" : language === "es" ? "Entender los datos estructurados: la guía" : "Understand structured data: the guide"} →
      </Link>
    </section>
  );
};
